import { getGrowthBookFeatureValue } from 'growthbook';

import { AbstractBroker } from './AbstractBroker';

let chartBroker: AbstractBroker | undefined;
export const setChartBroker = (broker: AbstractBroker) => {
  chartBroker = broker;
};
export const getChartBroker = () => {
  const isChartBrokerEnabled = getGrowthBookFeatureValue('is_chart_broker_enabled');

  if (!isChartBrokerEnabled) {
    return undefined;
  }

  return chartBroker;
};

export const brokerCallbacks: {
  closePosition: {
    resolve: ((value: boolean) => void) | undefined;
    reject: ((reason?: unknown) => void) | undefined;
  };
} = {
  closePosition: {
    resolve: undefined,
    reject: undefined,
  },
};
